import { render, staticRenderFns } from "./SmsDetail.vue?vue&type=template&id=66460d94&"
import script from "./SmsDetail.vue?vue&type=script&lang=ts&"
export * from "./SmsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports